import { Lesson } from "@jelly/lesson";
import { task as task01 } from "../../../task/course-05/lesson-02/task-01";
import { task as task02 } from "../../../task/course-05/lesson-02/task-02";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";

const lesson: Lesson = {
  id: "d4ff1c0f-9d6f-4cf1-8941-92fa0d46fc8c",
  publicId: "2",
  name: "How a room responds to sound",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [
    principle01,
    principle02,
    {
      title: "What are the three components of sound in a closed space?",
      description: "Select the correct answer.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        },
      },
    },
    {
      title: "How long does it typically take for early reflections to arrive at a receiver in a room?",
      description: "Select the correct answer.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        },
      },
    },
  ],
};

export default lesson;
